const border = '1px solid #E3E3E3';

export const styles = {
    container: {
        width: 224,
        borderRight: border,
        flexShrink: 0,
    },
    title: {
        margin: 0,
        width: '100%',
        padding: '13px 12px',
        fontFamily: 'Open Sans, Arial, sans-serif',
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'left',
        color: '#313140',
        borderBottom: border,
        borderRight: 0,
        boxSizing: 'border-box',
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
